import type { ITimelineEvents } from "@/types/timeline-type";

import dustIcon from "@/img/warning-icon/dust-1-icon.svg";
import fogIcon from "@/img/warning-icon/fog-1-icon.svg";
import frostIcon from "@/img/warning-icon/frost-1-icon.svg";
import hailIcon from "@/img/warning-icon/hail-1-icon.svg";
import rainfallIcon from "@/img/warning-icon/rainfall-1-icon.svg";
import highTempIcon from "@/img/warning-icon/high-temperature-1-icon.svg";
import highWavesIcon from "@/img/warning-icon/high-wave-1-icon.svg";
import thunderstormIcon from "@/img/warning-icon/thunderstorm-1-icon.svg";
import windIcon from "@/img/warning-icon/wind-1-icon.svg";

export const DEFAULT_TIMELINE: ITimelineEvents[] = [
	{
		event: "dust",
		value: 0,
		slots: [],
		icon: dustIcon,
	},
	{
		event: "fog",
		value: 0,
		slots: [],
		icon: fogIcon,
	},
	{
		event: "frost",
		value: 0,
		slots: [],
		icon: frostIcon,
	},
	{
		event: "hail",
		value: 0,
		slots: [],
		icon: hailIcon,
	},
	{
		event: "rainfall",
		value: 0,
		slots: [],
		icon: rainfallIcon,
	},
	{
		event: "highTemp",
		value: 0,
		slots: [],
		icon: highTempIcon,
	},
	{
		event: "highwaves",
		value: 0,
		slots: [],
		icon: highWavesIcon,
	},
	{
		event: "thunderstorm",
		value: 0,
		slots: [],
		icon: thunderstormIcon,
	},
	{
		event: "wind",
		value: 0,
		slots: [],
		icon: windIcon,
	},
];
